import { useEffect, useState } from "react";
import styled from "styled-components";
import { useIntersecting } from "../../../../../hooks/useIntersecting";
import { SectionProps } from "../../../shared/types";
import {
  colorV2,
  cssTemplate,
  media,
  pcContainerGap,
  typographyV2,
} from "../../../../../constants/styles";
import { Wrapper, maxWidth } from "../../../shared/styled";
import Responsable from "../../../../Responsable";

interface Props extends SectionProps {}

const ScrollOverlayPartners: React.FC<Props> = () => {
  const { ref, isIntersecting } = useIntersecting();
  const [interacted, setInteracted] = useState<boolean>(false);

  useEffect(() => {
    if (isIntersecting) setInteracted(true);
  }, [isIntersecting]);

  return (
    <Container ref={ref} theme={{ isIntersecting: interacted }}>
      <TextSectionWrapper>
        <TextSection>
          <h3>OutSourcing Service</h3>
          <Responsable
            pc={
              <h2>
                아웃소싱 사업부는 국내 최고 기업들과
                <br />
                원팀으로 비즈니스까지 함께 구축합니다
              </h2>
            }
            tablet={
              <h2>
                아웃소싱 사업부는
                <br />
                국내 최고 기업들과 원팀으로
                <br />
                비즈니스까지 함께 구축합니다
              </h2>
            }
            mobile={
              <h2>
                아웃소싱 사업부는
                <br />
                국내 최고 기업들과
                <br />
                원팀으로 비즈니스까지
                <br />
                함께 구축합니다
              </h2>
            }
          />
        </TextSection>
      </TextSectionWrapper>
    </Container>
  );
};

export default ScrollOverlayPartners;

const Container = styled.div`
  ${(props) => cssTemplate.fadeInOut(props)}
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: ${pcContainerGap};
`;

const SectionWrapper = styled(Wrapper)`
  align-items: flex-start;
  justify-content: flex-start;
  ${media.TABLET} {
    padding-right: 0px;
  }
`;

const TextSectionWrapper = styled(SectionWrapper)`
  gap: ${pcContainerGap};
  align-items: center;
  text-align: center;
  width: 100%;

  ${media.TABLET} {
    padding: 0px 48px;
  }
  ${media.MOBILE} {
    padding: 0px 24px;
  }
`;

const TextSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  ${maxWidth};

  /* 아웃소싱 사업부는 국내 최고 기업들과 */
  h2 {
    ${typographyV2.HEADING_1_B}
    color: ${colorV2.GRAY_10};
  }
  /* OutSourcing Service */
  h3 {
    ${typographyV2.BODY_2_M};
    color: ${colorV2.GRAY_10};
  }

  ${media.MOBILE} {
    max-width: 100%;

    /* 아웃소싱 사업부는 국내 최고 기업들과 */
    h2 {
      ${typographyV2.HEADING_3_B}
    }
    /* OutSourcing Service */
    h3 {
      ${typographyV2.BODY_4_M};
    }
  }
`;
